import { useWindowEventListener } from '../../hooks/useWindowEventListener';
import { ChevronDownIcon } from '../../assets/icons/common';
import styles from './style.module.scss';
import { useState } from 'react';

interface Props {
    label?: string;
    setItem: any;
    icon?: string;
    idKey: string;
    titleKey: string;
    selectedItem: any;
    disabled?: boolean;
    searchable?: boolean;
    dropDownList?: any[];
    errorMessage?: string;
    wrapperClassName?: string;
    containerClassName?: string;
    onClick?: () => void;
    placeholder?: string;
    isRequired?: boolean;
    showSelectedMode?: boolean;
};

function DropDown(props: Props) {
    const [showList, setShowList] = useWindowEventListener(closeList);
    const [searchTerm, setSearchTerm] = useState('');
    const [selected, setSelected] = useState(false);
    const {
        icon,
        idKey,
        label,
        onClick,
        setItem,
        disabled,
        titleKey,
        isRequired,
        searchable,
        dropDownList,
        selectedItem,
        errorMessage,
        placeholder,
        wrapperClassName,
        showSelectedMode,
        containerClassName,
    } = props;

    function closeList() {
        setShowList(false);
    };

    const clickOnDropDown = () => {
        if (disabled === true) return;
        setShowList(prevState => !prevState);
        setSelected(true);
        onClick && onClick();
    };

    return (
        <div className={`${styles.container} ${containerClassName}`}>
            {label && <span className={styles.label}>{label} {isRequired && <b>*</b>}</span>}
            <div className={styles.dropDown}>
                <div
                    className={`${styles.dropDown_slot} ${wrapperClassName}`}
                    data-has-error={Boolean(errorMessage)}
                    data-disabled={Boolean(disabled)}
                    data-show-selected={showSelectedMode && selected}
                    onClick={clickOnDropDown}
                >
                    <div className={styles.align_items_center}>
                        <i className={icon} />
                        <div
                            className={styles.dropDown_title}
                            data-item-selected={Boolean(selectedItem)}
                            data-disabled={Boolean(disabled)}
                        >
                            {selectedItem ? selectedItem[titleKey] : (placeholder || 'Select An Item')}
                        </div>
                    </div>
                    <ChevronDownIcon stroke='#0F172A' />
                </div>
                {dropDownList && showList && (
                    <div className={styles.list}>
                        {searchable && <input
                            type='text'
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            className={styles.searchInput}
                        />}
                        <ul>
                            {dropDownList.filter(i => i[titleKey].startsWith(searchTerm)).map(item => {
                                return (<li
                                    className={styles.selected}
                                    onClick={() => setItem(item)}
                                    key={item[idKey]}
                                >
                                    {item[titleKey]}
                                </li>)
                            })}
                        </ul>
                    </div>
                )}
            </div>
            {errorMessage && (<span className={styles.warning}>{errorMessage}</span>)}
        </div>
    );
};

export default DropDown;
